import Cookies from 'js-cookie'

export class CookieService {

  /**
   * ログイン状態かどうかを判定します
   *
   * @deprecated
   * aクッキーの有無を判定しており、仮会員でもtrueとなる。
   * 現在の他の実装で一般に使われている「ログイン」は本会員を意味するので差異があることに注意。
   */
  public static isLogined(): boolean {
    const accessToken = Cookies.get('a')

    return !(typeof accessToken === 'undefined' || accessToken === null)
  }

  /**
   * 会員種別が本登録かどうかを返します
   *
   * @deprecated
   * sクッキーによる判定は廃止する方向なので新規の利用はなるべく避ける。
   * https://github.com/Everforth/growthpalette-front/issues/7542
   * mc_sのセッションデータに検証済みの本会員フラグが含まれているので、そちらを利用することを推奨する。
   */
  public static isRegistered(): boolean {
    const userStatus = Cookies.get('s')

    return userStatus === 'registered'
  }

  /**
   * 会員種別が仮登録かどうかを返します
   *
   * @deprecated
   * sクッキーによる判定は廃止する方向なので新規の利用はなるべく避ける。
   * https://github.com/Everforth/growthpalette-front/issues/7542
   * mc_sのセッションデータに検証済みの本会員フラグが含まれているので、そちらを利用することを推奨する。
   */
  public static isProvisional(): boolean {
    const userStatus = Cookies.get('s')

    return !this.isGuest() && (userStatus === 'provisional' || !userStatus)
  }

  /**
   * ゲストユーザー（アクセストークンがない）かどうかを返します
   */
  public static isGuest(): boolean {
    const accessToken = Cookies.get('a')

    return typeof accessToken === 'undefined' || accessToken === null
  }
}
